import { BdaApplication } from "./BdaApplication"
import { BdaDataset } from "./BdaDataset"
import { BdaModel } from "./BdaModel"
import { BdaService } from "./BdaService"
import { AccessLevel, Organization, Owner } from "./generics"

export class Project {
  accessLevel: AccessLevel;
  bdaApplications: BdaApplication[];
  createDateTime?: string;
  datasets: BdaDataset[];
  deleteDateTime?: string;
  description: string;
  id?: number;
  img?: string;
  models: BdaModel[];
  name: string;
  organization?: Organization;
  owner?: Owner;
  services: BdaService[];
  updateDateTime?: string;
  tags: string[];

  constructor() {
    this.name = "";
    this.accessLevel = AccessLevel.TEAM;
    this.description = "";
    this.services = [];
    this.models = [];
    this.bdaApplications = [];
    this.datasets = [];
    this.tags = [];
  }
}